import { Box, Container, VStack } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

import { PageFooter } from './page-footer';
import { PageHeader } from './page-header';
import { SidebarDrawer } from './sidebar-drawer';

import { usePageLayout } from '#src/providers/page-layout-provider';

export function Layout() {
  const { footerMode } = usePageLayout();
  const isFixedFooter = footerMode === 'fixed';

  return (
    <Box
      minH="100vh"
      height={isFixedFooter ? '100vh' : undefined}
      bg="bg.subtle"
      display="flex"
      flexDirection="column"
      overflow={isFixedFooter ? 'hidden' : undefined}
    >
      <SidebarDrawer hideFixedToggle />
      <PageHeader />
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        minHeight={0}
        overflow={isFixedFooter ? 'auto' : undefined}
        style={{ backgroundColor: 'var(--background-base-color)' }}
      >
        <Container
          maxW="container.xl"
          pt={0}
          pb={isFixedFooter ? 0 : 8}
          px={4}
          mt={4}
          mb={isFixedFooter ? 4 : 0}
          flex={1}
          display="flex"
          flexDirection="column"
          minHeight={0}
        >
          <VStack gap={0} align="stretch" flex={1} minHeight={0}>
            <Box flex={1} minHeight={0} display="flex" flexDirection="column">
              <Outlet />
            </Box>
          </VStack>
        </Container>
      </Box>
      <PageFooter />
    </Box>
  );
}
